'use client'

export const SearchResultSkeleton = ({ count = 5 }: { count?: number }) => {
  return (
    <div className="py-2">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="flex items-center p-3 lg:p-2 border-b border-gray-100 last:border-b-0 bg-white"
        >
          {/* Thumbnail skeleton */}
          <div className="w-12 h-16 lg:w-10 lg:h-12 bg-gray-200 rounded-lg flex-shrink-0 animate-pulse" />

          {/* Content skeleton */}
          <div className="ml-3 lg:ml-3 flex-1 min-w-0">
            {/* Title skeleton */}
            <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4 mb-1" />
            {/* Creators skeleton */}
            <div className="h-3 bg-gray-200 rounded animate-pulse w-1/2" />
          </div>

          {/* Price skeleton */}
          <div className="ml-3 text-right flex-shrink-0">
            <div className="h-4 bg-gray-200 rounded animate-pulse w-12" />
          </div>
        </div>
      ))}
    </div>
  )
}

